// extracted by mini-css-extract-plugin
export default {"arrow":"Nudges_arrow__REuzC","animate":"Nudges_animate__3fgwx"};